import React, { useState, useEffect, useRef } from 'react';
import $ from 'jquery';
window.jQuery = window.$ = $;
require('jquery-nice-select');

const FormContactAgent = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        city: '',
        message: '',
        agree: false,
        budget: ''
    });

    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState('');
        const [loading, setLoading] = useState(false); // Added loading state
    const budgetRef = useRef(null);

    const validate = () => {
        let newErrors = {};

        if (!formData.name.trim()) newErrors.name = "Name is required";
        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Invalid email format";
        }
        if (!formData.phone.trim()) {
            newErrors.phone = "Phone is required";
        } else if (!/^\d{10}$/.test(formData.phone)) {
            newErrors.phone = "Phone must be 10 digits";
        }
        if (!formData.city.trim()) newErrors.city = "City is required";
        if (!formData.message.trim()) newErrors.message = "Message is required";
        if (!formData.agree) newErrors.agree = "You must authorize CoOwnSpace to contact you";
        if (!formData.budget) newErrors.budget = "Please select your budget";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    useEffect(() => {
        $(budgetRef.current).niceSelect();

        $(budgetRef.current).on('change', (e) => {
            setFormData((prevData) => ({ ...prevData, budget: e.target.value }));
        });

        return () => {
            $(budgetRef.current).off('change'); 
            $(budgetRef.current).niceSelect('destroy');
        };
    }, []);

    const handleChange = (e) => {
        const { name, type, checked, value } = e.target;
        setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
       
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) return;

        setLoading(true); // Start loading


        try {
            const response = await fetch(process.env.REACT_APP_SEND_EMAIL_AGENT, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });

            const data = await response.json();
           

            if (data.success) {
                setSuccess("Thank you! Your email has been sent successfully.");
                setFormData({ name: '', email: '', phone: '', city: '', message: '', agree: false, budget: '' });
                
            } else {
                setSuccess("Failed to send email. Try again later.");
            }
        } catch (error) {
            console.error("Fetch Error:", error);
            setSuccess("Error sending email. Try again later.");
        }finally {
            setLoading(false); // Stop loading
        }
    };

    return (
        <div>
            <form className="form-contact-agent" onSubmit={handleSubmit}>
                <h4 className="heading-title mb-30">Enquire Now</h4>                
                <fieldset>
                    <input type="text" className="form-control" placeholder="Your name" name="name" value={formData.name} onChange={handleChange} />
                    {errors.name && <small style={{ color: 'red' }}>{errors.name}</small>}
                </fieldset>
                
                <fieldset>
                    <input type="email" className="form-control" placeholder="Email" name="email" value={formData.email} onChange={handleChange} />
                    {errors.email && <small style={{ color: 'red' }}>{errors.email}</small>}
                </fieldset>
                
                <fieldset>
                    <input type="tel" className="form-control" placeholder="Phone" name="phone" value={formData.phone} onChange={handleChange} />
                    {errors.phone && <small style={{ color: 'red' }}>{errors.phone}</small>}
                </fieldset>
                
                <fieldset>
                    <input type="text" className="form-control" placeholder="City" name="city" value={formData.city} onChange={handleChange} />
                    {errors.city && <small style={{ color: 'red' }}>{errors.city}</small>}
                </fieldset>

                <div className="select custom-select-dropdown">
                    <fieldset>
                        <select ref={budgetRef} name="budget">
                            <option value="">Budget</option>
                            <option value="Below 5 Lakh">Below 5 Lakh</option>
                            <option value="5 to 10 Lakh">5 to 10 Lakh</option>
                            <option value="10 to 20 Lakh">10 to 20 Lakh</option>
                            <option value="Above 20 Lakh">Above 20 Lakh</option>
                        </select>
                    </fieldset>
                    {errors.budget && <small style={{ color: 'red' }}>{errors.budget}</small>}
                </div>

                <fieldset>
                    <textarea name="message" cols="0" rows="0" className="form-control" placeholder="Message" value={formData.message} onChange={handleChange}></textarea>
                    {errors.message && <small style={{ color: 'red' }}>{errors.message}</small>}
                </fieldset>
                
                <fieldset>
                    <label>
                        <input type="checkbox" name="agree" checked={formData.agree} onChange={handleChange} />
                        <span className="ms-2 text-3 text-color-default">By submitting, you authorize CoOwnSpace to contact you.</span>
                    </label>
                    {errors.agree && <small style={{ color: 'red' }}>{errors.agree}</small>}
                </fieldset>
                
                <div className="wrap-btn">
                <button type="submit" className="tf-btn bg-color-primary fw-6 w-full" disabled={loading}>
                        {loading ? "Sending..." : "Send Email"}
                    </button>                </div>
                {success && <div className={success && success.includes('successfully') ? 'text-success' : 'text-danger'}>{success}</div>}
            </form>


        </div>
    );
};

export default FormContactAgent;
